import { render, staticRenderFns } from "./KilimanjaroRu.vue?vue&type=template&id=8e5d4bfa&scoped=true&"
import script from "./KilimanjaroRu.vue?vue&type=script&lang=js&"
export * from "./KilimanjaroRu.vue?vue&type=script&lang=js&"
import style0 from "./KilimanjaroRu.vue?vue&type=style&index=0&id=8e5d4bfa&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5d4bfa",
  null
  
)

export default component.exports